export default __webpack_public_path__ + "static/media/img-0736-latvia-half-face.b06216ac.png";